import styled from 'styled-components';

export const ContentRow = styled.div`
  display: flex;
  gap: 16px;
  position: relative;
  padding-top: 16px;
`;
